import React from 'react'
import { getAbbreviatedNumberString } from 'components/Income/Income'

const riseStatisticIconUrl = require('../../../../../icons/rise.svg')
const dropStatisticIconUrl = require('../../../../../icons/drop.svg')

export interface IActivityTopBarStatisticsData {
  totalEntities: number
  inflows: number
  outflows: number
  profitLoss: number
  profitLossType: 'decrease' | 'increase' | null
  reportedIncomeTax: number | null
  unReportedIncomeTax: number | null
  reportedSalesTax: number | null
  unReportedSalesTax: number | null
}

export const getActivityTopBarStatisticsData = (overview: IActivityTopBarStatisticsData) => [
  {
    label: 'Inflows',
    value: `$${getAbbreviatedNumberString(overview.inflows)}`,
    tooltipHeader: 'Inflows',
    tooltipText:
      'The total amount of cryptocurrency received across the selected address(es). Includes all incoming transactions such as deposits, payments, or transfers.',
  },
  {
    label: 'Outflows',
    tooltipHeader: 'Outflows',
    value: `$${getAbbreviatedNumberString(overview.outflows)}`,
    tooltipText:
      'The total amount of cryptocurrency sent from the selected address(es). Includes withdrawals, expenses, or transfers to other wallets.',
  },
  {
    label: 'Gain/Loss',
    tooltipHeader: 'Gain/Loss',
    value: (
      <>
        {overview.profitLossType === 'increase' && <img src={riseStatisticIconUrl} alt='increase' />}
        {overview.profitLossType === 'decrease' && <img src={dropStatisticIconUrl} alt='decrease' />}
        {`$${getAbbreviatedNumberString(overview.profitLoss)}`}
      </>
    ),
    tooltipText:
      'Total revenue from sales, mints, and royalties, minus fees and cost basis (initial purchase price of the asset)',
  },
  {
    label: 'Reported | Unreported Income Tax',
    value: (
      <>
        {typeof overview.reportedIncomeTax === 'number'
          ? getAbbreviatedNumberString(overview.reportedIncomeTax)
          : '----'}
        {' | '}
        {typeof overview.unReportedIncomeTax === 'number' ? (
          <span style={{ color: '#FF4D4F' }}>{getAbbreviatedNumberString(overview.unReportedIncomeTax)}</span>
        ) : (
          '----'
        )}
      </>
    ),
  },
  {
    label: 'Reported | Unreported Sales Tax / VAT',
    comingSoon: true,
    value: (
      <>
        {typeof overview.reportedSalesTax === 'number' ? getAbbreviatedNumberString(overview.reportedSalesTax) : '----'}
        {' | '}
        {typeof overview.unReportedSalesTax === 'number' ? (
          <span style={{ color: '#FF4D4F' }}>{getAbbreviatedNumberString(overview.unReportedSalesTax)}</span>
        ) : (
          '----'
        )}
      </>
    ),
  },
]
